module.exports = __webpack_public_path__ + "static/img/025.0a24cb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/editor/025.png
// module id = k+46
// module chunks = 3